// Mapper: transport LC_GetTodayAbsenceSummaryOut → domain model for the
// "Mi equipo" dashboard "Situación de asistencia" section — "Ausentes" card
// (ASIS-5406 / REXASIS-005).
// The backend only sends the raw counts; the percentage/isEmpty business rules are
// computed here so the UI never re-implements them.

import type {
  LC_GetTodayAbsenceSummaryOut,
  MyTeamAbsenceSummary,
} from '../types/myTeamAbsenceSummary.types';


export function mapMyTeamAbsenceSummary(
  out: LC_GetTodayAbsenceSummaryOut,
): MyTeamAbsenceSummary {
  const isEmpty = out.totalSupervisedCount === 0;
  const percentage = isEmpty
    ? 0
    : Math.round((out.unjustifiedCount / out.totalSupervisedCount) * 100);

  return {
    unjustifiedCount: out.unjustifiedCount,
    justifiedCount: out.justifiedCount,
    totalSupervisedCount: out.totalSupervisedCount,
    percentage,
    isEmpty,
  };
}
